import React from 'react';
import ProductCard from './ProductCard';

export default function ProductListing({ invoiceData }: any) {
  return (
    <div className="screen-width">
      <div className="product-list-container">
        {invoiceData.documentDetails.addItems.items.map(
          (item: any, key: number) => (
            <ProductCard
              item={item}
              isLastProduct={
                invoiceData.documentDetails.addItems.items.length == key + 1
              }
            />
          )
        )}
      </div>
    </div>
  );
}
